"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ConditionalWrapper = ({ condition, wrapper, children, }) => condition
    ? wrapper(children)
    : children;
exports.default = ConditionalWrapper;
